import { createTrackingUtils } from "..";
import useProfiler from "../../../hooks/useProfiler";
import { useFlightsWebMdotExtrasContentHierarchy } from "./flights_web_mdot_extras_content_hierarchy";

const utils = createTrackingUtils({
  name: "flights_web_allow_skip_extras",
  stages: {
    main: 1,
    desktop: 2,
    mdot: 3,
    flexOrCfar: 4,
    insurance: 5,
    fastTrack: 6,
    lowInsuranceProb: 7,
    lowFlexProb: 8,
    expOverlap: 9
  },
  defaultStage: 1,
  goals: {
    extrasSkipped: 1,
    noFlexAdded: 2,
    flexOrCfarAdded: 3,
    noInsuranceAdded: 4,
    click_pay_with_flex_cfar_bf: 5
  }
});

const useTrackStages = (insuranceProb: Boolean, flexProb: Boolean) => {
  const { stages } = utils;
  const { isDesktop } = useProfiler();
  const { isVariant } = useFlightsWebMdotExtrasContentHierarchy();

  stages.main();
  isDesktop() ? stages.desktop() : stages.mdot();
  isVariant() && stages.expOverlap();
  insuranceProb && stages.lowInsuranceProb();
  flexProb && stages.lowFlexProb();
};
export default { ...utils, useTrackStages };
